import React from "react";
import { Mail, ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { profile } from "../data/mock";
import SocialLinks from "./SocialLinks";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-[#1E90FF]/15 bg-[#05070B]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={profile.logo}
                alt="Bluebloodfr logo"
                className="w-10 h-10 object-contain"
              />
              <div>
                <div className="text-[#F3F6FA] font-bold tracking-wider">
                  BLUEBLOODFR
                </div>
                <div className="text-[#A1A7B3] text-[10px] tracking-[0.25em]">
                  DATA • AI • DEVELOPMENT
                </div>
              </div>
            </div>
            <p className="mt-5 text-[#A1A7B3] text-sm leading-relaxed max-w-sm">
              Reliable AI, data and software solutions — designed for real-world use.
            </p>
          </div>

          <div>
            <div className="text-[#F3F6FA] font-semibold text-sm tracking-widest mb-4">
              NAVIGATION
            </div>
            <ul className="space-y-2 text-sm">
              {[
                ["About", "/#about"],
                ["Projects", "/#projects"],
                ["Experience", "/#experience"],
                ["Skills", "/#skills"],
                ["AI Assistant", "/#assistant"],
                ["Contact", "/#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={`footer-nav-${label.toLowerCase().replace(/\s+/g, "-")}-link`}
                    className="text-[#C8CED8] hover:text-[#1E90FF] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="text-[#F3F6FA] font-semibold text-sm tracking-widest mt-8 mb-4">
              COACHING
            </div>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/ai-coaching" hrefLang="en" data-testid="footer-coaching-en-link"
                  className="text-[#C8CED8] hover:text-[#1E90FF] transition-colors">
                  AI coaching &amp; Python tutoring
                </Link>
              </li>
              <li>
                <Link to="/cours-ia" hrefLang="fr" data-testid="footer-coaching-fr-link"
                  className="text-[#C8CED8] hover:text-[#1E90FF] transition-colors">
                  Cours particuliers d’IA (FR)
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[#F3F6FA] font-semibold text-sm tracking-widest mb-4">
              GET IN TOUCH
            </div>
            <div className="flex flex-col gap-3 text-sm">
              <a
                href={`mailto:${profile.email}`}
                data-testid="footer-email-link"
                className="text-[#C8CED8] hover:text-[#1E90FF] transition-colors flex items-center gap-2"
              >
                <Mail size={14} /> {profile.email}
              </a>
              <SocialLinks testIdPrefix="footer-social" />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#1E90FF]/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-[#A1A7B3] text-xs tracking-wider">
            © {year} Louis-Melchior Giraud — Bluebloodfr. All rights reserved.
          </div>
          <a
            href="#top"
            data-testid="footer-back-to-top-link"
            className="inline-flex items-center gap-2 text-[#1E90FF] hover:text-[#F3F6FA] text-xs tracking-widest transition-colors"
          >
            BACK TO TOP <ArrowUp size={14} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
